const colors = {
  defaultTextColor: "#222222",
  defaultBorderColor: "#cbcbcb",
  blue: "#1fb6ff",
  darkblue: "#15193F",
  yellow: "#F8B42E",
  secondary: "#F19100",
  orange: "#EA4B25",
  cleargray: "#A7A7A7",
};
export const alignField = {
  type: "radio",
  options: [
    { label: "Left", value: "start" },
    { label: "Center", value: "center" },
    { label: "Right", value: "end" },
  ],
};

export const headingTagField = {
  type: "select",
  options: [
    { label: "H1", value: "h1" },
    { label: "H2", value: "h2" },
    { label: "H3", value: "h3" },
    { label: "H4", value: "h4" },
    { label: "H5", value: "h5" },
    { label: "H6", value: "h6" },
  ],
};
export const headingSizeField = {
  type: "select",
  options: [
    { label: "Normal", value: "" },
    { label: "Small", value: "text-sm" },
    { label: "Medium", value: "text-md" },
    { label: "Large", value: "text-lg" },
    { label: "Extra Large", value: "text-xl" },
    { label: "2xl", value: "text-2xl" },
    { label: "3xl", value: "text-3xl" },
    { label: "4xl", value: "text-4xl" },
    { label: "5xl", value: "text-5xl" },
    { label: "6xl", value: "text-6xl" },
    { label: "7xl", value: "text-7xl" },
    { label: "8xl", value: "text-8xl" },
    { label: "9xl", value: "text-9xl" },
  ],
};
export const fontWeightField = {
  type: "select",
  options: [
    { label: "Normal", value: "" },
    { label: "Bold", value: "font-bold" },
    { label: "Medium", value: "font-medium" },
    { label: "Light", value: "font-light" },
  ],
};
export const borderRadiusField = {
  type: "select",
  options: [
    { label: "None", value: "" },
    { label: "Small", value: "rounded-sm" },
    { label: "Medium", value: "rounded-md" },
    { label: "Large", value: "rounded-lg" },
    { label: "Extra Large", value: "rounded-xl" },
  ],
};
export const boxShadowField = {
  type: "select",
  options: [
    { label: "None", value: "" },
    { label: "XL", value: "shadow-xl" },
    { label: "XL/20", value: "shadow-xl/20" },
    { label: "XL/30", value: "shadow-xl/30" },
    { label: "XL/50", value: "shadow-xl/50" },
  ],
};
// Spacing fields below produce literal Tailwind classes so the renderer can
// drop them straight into className. Sizes mirror Tailwind's spacing scale;
// keep this list in sync with the safelist on the public site
// (paodiario-org-br/tailwind.config.ts).
const SPACING_SIZES = ["1", "2", "3", "4", "5", "6", "8", "10", "12"];

function makeSpacingField(prefix) {
  return {
    type: "select",
    options: [
      { label: "None", value: "" },
      ...SPACING_SIZES.map((n) => ({ label: n, value: `${prefix}-${n}` })),
    ],
  };
}

export const paddingField = makeSpacingField("p");
export const paddingXField = makeSpacingField("px");
export const paddingYField = makeSpacingField("py");
export const marginField = makeSpacingField("m");
export const marginXField = makeSpacingField("mx");
export const marginYField = makeSpacingField("my");
export const borderWidthField = {
  type: "select",
  options: [
    { label: "None", value: "" },
    { label: "thin", value: "border" },
    { label: "double", value: "border-2" },
    { label: "thick", value: "border-4" },
    { label: "thicker", value: "border-6" },
  ],
};

export const borderColorField = {
  type: "select",
  options: [
    { label: "None", value: "" },
    { label: "default", value: "border" },
    { label: "blue", value: "border-blue-50" },
    { label: "darkblue", value: `border-[${colors.darkblue}]` },
    { label: "yellow", value: `border-[${colors.yellow}]` },
    { label: "secondary", value: `border-[${colors.secondary}]` },
    { label: "orange", value: `border-[${colors.orange}]` },
    { label: "gray", value: "border-gray-300" },
    { label: "cleargray", value: "border-gray-100" },
  ],
};
export const backgroundColorField = {
  type: "select",
  options: [
    { label: "None", value: "" },
    { label: "default", value: "bg-default" },
    { label: "blue", value: "bg-blue-50" },
    { label: "darkblue", value: `bg-[${colors.darkblue}]` },
    { label: "yellow", value: `bg-[${colors.yellow}]` },
    { label: "secondary", value: `bg-[${colors.secondary}]` },
    { label: "orange", value: `bg-[${colors.orange}]` },
    { label: "gray", value: "bg-gray-300" },
    { label: "cleargray", value: "bg-gray-100" },
  ],
};

export const spacingFields = {
  padding: paddingField,
  paddingX: paddingXField,
  paddingY: paddingYField,
  margin: marginField,
  marginX: marginXField,
  marginY: marginYField,
};
export const borderFields = {
  borderRadius: borderRadiusField,
  borderWidth: borderWidthField,
  borderColor: borderColorField,
  boxShadow: boxShadowField,
};
export const boxFields = {
  backgroundColor: backgroundColorField,
};
